import log from "loglevel";
import React, { useState, useEffect } from 'react'
import httpService from 'services/httpService.js';
import MarkdownIt from 'markdown-it';
import Editor from 'react-markdown-editor-lite'
import MarkdownPreview from '@uiw/react-markdown-preview';

import 'react-markdown-editor-lite/lib/index.css';
import katex from 'markdown-it-katex';
import MarkdownItImsize from 'markdown-it-imsize';
import Katex from './plugins/Katex';
import "./style.css";
// Initialize a markdown parser
const MdParser = new MarkdownIt({
    html: true,
    linkify: true,        // Autoconvert URL-like text to links
    typography: true
});

MdParser.use(katex, { "throwOnError": true, "errorColor": " #cc0000" });
Editor.use(Katex);
MdParser.use(MarkdownItImsize, { autofill: true });

// export default class MarkdownEditor extends React.Component<{}, IState> {
// constructor(props) {
//     super(props);
//     this.state = {
//         markdown: props.markdown,
//     };

// }
const EditorMd = (props) => {
    // log.log({val: props.value});
    const [markdown, setMarkdown] = useState("");
    const { onBlurAction, previousResponseText, preview, forwardedRef, placeholder, name, defaultValue, onChange, value, disabled } = props;


    const handleEditorChange = ({ html, text }) => {
        // log.log({html, text});
        setMarkdown(text);
        if (typeof onChange === "function") {
            onChange({ html, text });
        }
    }

    useEffect(() => {
        if (value) {
            setMarkdown(value);
        } else if (defaultValue) {
            setMarkdown(defaultValue)
        }
    }, [props, value]);

    // const handleImageUpload = (file) => {
    //     return new Promise(resolve => {
    //         const formData = new FormData()
    //         formData.append('myFile', file);

    //         fetch('/util/uploadUserFiles', {
    //             method: 'POST',
    //             headers: { 'X-CSRFToken': getCookie('csrftoken') },
    //             body: formData
    //         })
    //             .then(response => response.json())
    //             .then(data => {
    //                 resolve(data.url)
    //             })
    //             .catch(error => {
    //                 log.error(error)
    //             })
    //     });
    // };

    const onImageUpload = (progressEvent) => {
        // log.log({progressEvent});
    }

    const handleImageUpload = async (file) => {
        try {
            const formData = new FormData()
            formData.append('myFile', file);
            const response = await httpService.post('/util/uploaduserfiles', formData, { onUploadProgress: onImageUpload });
            log.log({ handleImageUpload_response: response });
            if (response.status === 200) {
                // log.log(response);
                return response.data.url;
            }
        } catch (error) {
            log.log(error);
        }
        // return new Promise(resolve => {
        //     const formData = new FormData()
        //     formData.append('myFile', file);

        //     fetch('/util/uploadUserFiles', {
        //         method: 'POST',
        //         headers: { 'X-CSRFToken': getCookie('csrftoken') },
        //         body: formData
        //     })
        //         .then(response => response.json())
        //         .then(data => {
        //             resolve(data.url)
        //         })
        //         .catch(error => {
        //             log.error(error)
        //         })
        // });
    };

    const onCustomImageUpload = (event) => {
        // log.log('onCustomImageUpload', event);
        return new Promise((resolve, reject) => {
            const result = window.prompt('Please enter image url here...');
            resolve({ url: result });
            // custom confirm message pseudo code
            // YourCustomDialog.open(() => {
            //     setTimeout(() => {
            //         // setTimeout 模拟oss异步上传图片
            //         // 当oss异步上传获取图片地址后，执行calback回调（参数为imageUrl字符串），即可将图片地址写入markdown
            //         const url = 'https://avatars0.githubusercontent.com/u/21263805?s=80&v=4'
            //         resolve({ url: url, name: 'pic' })
            //     }, 1000)
            // })
        });
    };

    return (
        <Editor
            ref={forwardedRef}
            name={name}
            config={{ linkUrl: 'Enter link url here', view: { html: false, md: true, menu: true } }}
            imageAccept='.jpg, .jpeg, .gif, .png, .bmp, .webp'
            placeholder={placeholder}
            defaultValue={previousResponseText}
            value={markdown}
            style={{ height: "100%" }}
            disabled={props.disabled}
            renderHTML={(text) => MdParser.render(text || "")}
            onChange={handleEditorChange}
            onImageUpload={handleImageUpload}
            onBlur={(markdown) => typeof onBlurAction === 'function' ? onBlurAction(markdown) : null}
            previewOptions={<MarkdownPreview source={markdown} />}
            preview='preview'
        // onCustomImageUpload={this.onCustomImageUpload.bind(this)}
        />
    );
}

const MdEditor = React.forwardRef((props, ref) => {
    // log.log({props, ref})
    return <EditorMd {...props} forwardedRef={ref} />;
});


export { MdEditor, MdParser };